import { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import BannerTitle from './BannerTitle';
import BannerSubtitle from './BannerSubtitle';

export type BannerProps = {
  className?: string;
  title?: string;
  subtitle?: string;
  number?: string;
};

const COLORS = {
  communitiesBorder: '#ddeaeb',
  communitiesGradient: 'linear-gradient(90deg, #effbfe 8.22%, #b1eafd)',
  servicesBorder: '#FFC2CB',
  servicesGradient: 'linear-gradient(90deg, #F9F2F5 0%, #FFACC3 100%)',
  neighborhoodsBorder: '#84EBB6',
  neighborhoodsGradient: 'linear-gradient(90deg, #E8FFF3 0%, #94E9BD 100%)',
  policyBorder: '#FFB0A1',
  policyGradient: 'linear-gradient(90deg, #FFF4EE 0%, #FFC9B0 100%)',
};

const BodyContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

interface BannerRootProps {
  pillarType: string;
}

const getBannerStyles = (pillarType: string) => {
  switch (pillarType) {
    case 'Services':
      return css`
        border: 1px solid ${COLORS.servicesBorder};
        background: ${COLORS.servicesGradient};
      `;
    case 'Neighborhoods':
      return css`
        border: 1px solid ${COLORS.neighborhoodsBorder};
        background: ${COLORS.neighborhoodsGradient};
      `;
    case 'Policies':
      return css`
        border: 1px solid ${COLORS.policyBorder};
        background: ${COLORS.policyGradient};
      `;
    case 'Communities':
    default:
      return css`
        border: 1px solid ${COLORS.communitiesBorder};
        background: ${COLORS.communitiesGradient};
      `;
  }
};

const BannerRoot = styled.div<BannerRootProps>`
  width: 100%;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 22px 15px;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  font-size: 24px;
  font-family: Montserrat;

  ${props => getBannerStyles(props.pillarType)}
`;

const Banner: FunctionComponent<BannerProps> = ({
  className = '',
  title = 'Communities',
  subtitle = 'Community leadership, Commitment and Public will to make early Childhood a Priority',
  number = '1',
}) => {
  return (
    <BannerRoot className={className} pillarType={title}>
      <BodyContainer>
        <BannerTitle title={title} number={number} />
        <BannerSubtitle subtitle={subtitle} />
      </BodyContainer>
    </BannerRoot>
  );
};

export default Banner;
